import { useMutation } from "react-query";
import { AreaComumTaxasForm } from "../typings";
import http from "infra/http";

function useSaveTaxasAreaComum(tenantId: string) {
  return useMutation(
    (data: AreaComumTaxasForm) => {
      return http.post(`/v1/tenants/${tenantId}/area-comum/${data.id}/taxas`, data);
    },
    { retry: false }
  );
}

export default useSaveTaxasAreaComum;
